export const UPDATE_HOUSE = 'UPDATE_HOUSE';
export const UPDATE_WORK = 'UPDATE_WORK';
export const SET_TOGGLES_EXTERNAL = 'SET_TOGGLES_EXTERNAL';

export function updateHouse(lat_lng) {
  lat_lng.lat = parseFloat(lat_lng.lat);
  lat_lng.lng = parseFloat(lat_lng.lng);
  return {type: UPDATE_HOUSE, payload: lat_lng};
}

export function updateWork(lat_lng) {
  lat_lng.lat = parseFloat(lat_lng.lat);
  lat_lng.lng = parseFloat(lat_lng.lng);
  return {type: UPDATE_WORK, payload: lat_lng};
}

export function setTogglesExternal(arrayOfToggles) {
  return {type: SET_TOGGLES_EXTERNAL, payload: arrayOfToggles};
}



// WEBPACK FOOTER //
// ./src/actions/Map/surveyActions.js